import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-issue',
  templateUrl: './delete-issue.component.html',
  styleUrls: ['./delete-issue.component.css']
})
export class DeleteIssueComponent implements OnInit {

  deleteId: any = "";
  materials: any = [];

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

 constructor(private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllIssues(this.pageNumber,this.recordsPerPage)
  }

  cancelModel(){
    document.getElementById("closeModalButton1")?.click()
  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getAllIssues(this.pageNumber-1,this.recordsPerPage)
  }

  getAllIssues(pageNumber:any,recordsPerPage:any){
    this.generic_service.getAllIssues(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        this.materials = response.response.materialIssueList;
        this.totalRecords = response.response.totalRecords;
        console.log(response)
      }
    )
  }

  deleteIssue(){
    this.generic_service.deleteIssue(this.deleteId).subscribe(
    (res:any)=>{
      console.log(res)
      this.toastr.success("Successfully deleted");
      this.getAllIssues(0,this.recordsPerPage)
      this.cancelModel();
    },err=>{
      console.log(err)
      this.toastr.error(err.error.errors[0].description);
    }
    )
  }
  
  del(id:any){
  this.deleteId = id
  }

}
